export default {
    linkReopenSelectedCard: {
        dataTrackId: 'link-reopen-selected-card',
        dataTrackLinkname: 'apne kortet',
    },
    linkHardBlockSelectedCard: {
        dataTrackId: 'link-hard-block-selected-card',
        dataTrackLinkname: 'sperr kortet permanent',
    },
    linkContactUs: {
        dataTrackId: 'link-contact-us',
        dataTrackLinkname: 'kontakt oss',
    },
    linkReorderSelectedCard: {
        dataTrackId: 'link-reorder-selected-card',
        dataTrackLinkname: 'rebestill kort',
    },
    digitalCard: {
        dataTrackId: 'digital-card',
        dataTrackLinkname: 'se digitalt kort',
    },
    linkSpendingLimits: {
        dataTrackId: 'link-spending-limits',
        dataTrackLinkname: 'brukstillatelser',
    },
    cardAbout: {
        dataTrackId: 'card-about',
        dataTrackLinkname: 'om kortet',
    },
    cardAboutEntryButtonOppsigelseAvKredittkort: {
        dataTrackId: 'card-about-entry-button',
        dataTrackLinkname: 'oppsigelse av kredittkort',
    },
    cardAboutEntryButtonRegionsperre: {
        dataTrackId: 'card-about-entry-button',
        dataTrackLinkname: 'regionsperre og bruk',
    },
    cardAboutEntryButtonAdditionalCard: {
        dataTrackId: 'card-about-entry-button',
        dataTrackLinkname: 'additional card',
    },
    cardAboutEntryButtonBrukstillatelser: {
        dataTrackId: 'card-about-entry-button',
        dataTrackLinkname: 'brukstillatelser',
    },
    cardAboutEntryButtonReklamasjon: {
        dataTrackId: 'card-about-entry-button',
        dataTrackLinkname: 'reklamasjon',
    },
    cardAboutEntryButtonChangeDueDate: {
        dataTrackId: 'card-about-change-due-date',
        dataTrackLinkname: 'Endre forfall',
    },
    cardAboutEntryButtonFordelsprogram: {
        dataTrackId: 'card-about-entry-button',
        dataTrackLinkname: 'fordelsprogram',
    },
    cardAboutEntryButtonFakturaOgDokumenter: {
        dataTrackId: 'card-about-entry-button',
        dataTrackLinkname: 'faktura og dokumenter',
    },
    cardAboutEntryButtonForsikringsbevis: {
        dataTrackId: 'card-about-entry-button',
        dataTrackLinkname: 'forsikringsbevis',
    },
    cardFunctionalityButtons: {
        dataTrackId: 'card-functionality-buttons',
        dataTrackLinkname: 'kort funksjonalitet knapper',
    },
    cardFunctionalityButtonSperrKort: {
        dataTrackId: 'card-functionality-button',
        dataTrackLinkname: 'sperr/erstatt kort',
    },
    cardFunctionalityButtonReorder: {
        dataTrackId: 'card-functionality-button',
        dataTrackLinkname: 'rebestill kort',
    },
    cardFunctionalityButtonVisPIN: {
        dataTrackId: 'card-functionality-button',
        dataTrackLinkname: 'se pin-kode',
    },
    cardFunctionalityLinks: {
        dataTrackId: 'card-functionality-links',
        dataTrackLinkname: 'kort funksjonalitet lenker',
    },
    cardFunctionalityLinkTransaksjoner: {
        dataTrackId: 'card-functionality-link',
        dataTrackLinkname: 'se transaksjoner',
    },
    cardFunctionalityLinkVerdiregnskap: {
        dataTrackId: 'card-functionality-link',
        dataTrackLinkname: 'verdiregnskap',
    },
    cardFunctionalityCardDetailsModalOpen: {
        dataTrackId: 'card-functionality-link',
        dataTrackLinkname: 'apne-kortdetaljer-modal',
    },
    cardSettings: {
        dataTrackId: 'card-settings',
        dataTrackLinkname: 'innstillinger',
    },
    cardSettingsEntryButtonGoogleWallet: {
        dataTrackId: 'card-settings-entry-button',
        dataTrackLinkname: 'google wallet',
    },
    cardSettingsEntryButtonBrukstillatelser: {
        dataTrackId: 'card-settings-entry-button',
        dataTrackLinkname: 'brukstillatelser',
    },
    cardSettingsEntryButtonEndreKredittgrense: {
        dataTrackId: 'card-settings-entry-button',
        dataTrackLinkname: 'endre kredittgrense',
    },
    cardOrderProgressOrdered: {
        dataTrackId: 'card-order-progress',
        dataTrackLinkname: `[ORDERED, SENT_TO_PRODUCTION, PRODUCTION_STARTED, SENT_TO_CUSTOMER]`,
    },
    cardOrderProgressSentToProduction: {
        dataTrackId: 'card-order-progress',
        dataTrackLinkname: `[ORDERED, SENT_TO_PRODUCTION, PRODUCTION_STARTED, SENT_TO_CUSTOMER]`,
    },
    cardOrderProgressProductionStarted: {
        dataTrackId: 'card-order-progress',
        dataTrackLinkname: `[ORDERED, SENT_TO_PRODUCTION, PRODUCTION_STARTED, SENT_TO_CUSTOMER]`,
    },
    cardOrderProgressSentToCustomer: {
        dataTrackId: 'card-order-progress',
        dataTrackLinkname: `[ORDERED, SENT_TO_PRODUCTION, PRODUCTION_STARTED, SENT_TO_CUSTOMER]`,
    },
};
